import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaitingIconFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 11 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.5001 1.57129C6.16347 1.57129 6.81604 1.73927 7.39696 2.05957C7.97787 2.37986 8.46823 2.84205 8.82229 3.40302C9.17636 3.964 9.38261 4.60549 9.42181 5.2677C9.46101 5.92991 9.33189 6.59126 9.04648 7.19009C8.76107 7.78893 8.32867 8.30573 7.7896 8.69233C7.25053 9.07893 6.62234 9.32273 5.96361 9.40099C5.30487 9.47926 4.63705 9.38944 4.0224 9.13992C3.40775 8.8904 2.86629 8.4893 2.44851 7.97402L5.5001 5.49986V1.57129Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 5.5,
		cy: 5.5,
		r: 5,
		stroke: "currentColor"
	})]
});
export default SvgWaitingIconFilled;
